"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- ヘッダーシャドー ----- */
$(function () {
  $(window).on('scroll', function () {
    if ($('.fv, .fvSub').height() < $(this).scrollTop()) {
      $('.header').addClass('change-color');
    } else {
      $('.header').removeClass('change-color');
    }
  });
});

/* ----- 年月別アーカイブのアコーディオン ----- */
$(".side__year").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});



/* ----- fvースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".splide__fv", {
    // Splideの設定
    type: "fade", // フェード
    autoplay: true, // 自動再生
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false, // 矢印ボタンを非表示
    interval: 5000,
    speed: 2000,
    perPage: 1,
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  }).mount();
}

/* ----- detailスライダー ----- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector("#splide02")) {
    // メインスライダー
    const main = new Splide("#splide02", {
      // autoplay: true, // 自動再生
      type: "fade", // フェード
      pagination: false, // ページネーション非表示
      arrows: false, // 矢印非表示
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    });
    // サムネイル
    const thumbnails = new Splide("#thumbnail-carousel", {
      perPage: 10, // サムネイル10枚表示
      pagination: false, // ページネーション非表示
      arrows: false, // 矢印非表示
      isNavigation: true, // 他のスライダーのナビゲーションとしてそれぞれのスライドをクリック可能にする
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
      perMove: 1,  // スライドするときの画像数
      breakpoints: {
        768: {
          perPage: 5, // モバイル表示時にはサムネイルを5枚に制限
          arrows: true, // 矢印非表示
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
});

/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;
// スマホサイズの時の追加オフセット（必要に応じて調整）
const mobileOffset = -100; // 50px 追加オフセット
// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};
// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}

/* ----- フェードイン ----- */
window.addEventListener('scroll', function(){
  // スクロール量を取得
  const scroll = window.scrollY;
  // 画面の高さを取得
  const windowHeight = window.innerHeight;
  // すべての.boxを取得
  const boxes = document.querySelectorAll('.fade');

  boxes.forEach(function(box) {
    // boxまでの高さを取得
    const distanceToBox = box.offsetTop;
    // 下記条件が成り立つときだけboxにis-activeクラスを付与する
    if(scroll + windowHeight > distanceToBox) {
      box.classList.add('is-active');
    }
  });
});



/* ----- インスタプラグイン hoverアクション ----- */
document.addEventListener("DOMContentLoaded", function() {
  const sbiItems = document.querySelectorAll('.sbi_item');

  sbiItems.forEach(item => {
    const textContainer = document.createElement('div');
    textContainer.classList.add('topInstagram__text');
    textContainer.innerHTML = '詳細をチェック<br><span>Instagram</span>';

    item.appendChild(textContainer);
  });
});



